import type { TrackRole } from "./music.ts";

export const AUDIO_SOURCE_GAINS = {
  clickAccent: 0.24,
  clickRegular: 0.17,
  piano: 0.22,
  sustainedPiano: 0.2,
  reference: 0.16,
  editMelody: 0.28,
  bass: 0.25,
  strings: 0.13,
  synth: 0.15,
} as const;

const roleGain: Record<TrackRole, number> = {
  melody: AUDIO_SOURCE_GAINS.editMelody,
  bass: AUDIO_SOURCE_GAINS.bass,
  strings: AUDIO_SOURCE_GAINS.strings,
  synth: AUDIO_SOURCE_GAINS.synth,
};

export function playbackSourceGain(role: TrackRole, velocity = 100): number {
  const velocityScale = Math.max(0.76, Math.min(1.05, 0.72 + Math.max(0, Math.min(127, velocity)) / 127 * 0.33));
  return roleGain[role] * velocityScale;
}
